<script setup lang="ts">
/**
 * Document-with-magnifier glyph for the consolidated Rapportage entry (reports
 * + audit log) — "inspect the paperwork". Same conventions as IconInfo.vue:
 * inline SVG so it stays crisp at any size, `currentColor` so it inherits the
 * nav link's colour states, sized in `em`, and `aria-hidden` because the
 * calling link carries the accessible name.
 *
 * The magnifier sits CENTRED on the document, lens fully inside the page and
 * only the handle breaking the lower-right edge — read as "inspecting the
 * document", not as two glyphs shoved together.
 */
</script>

<template>
  <svg
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <!-- Document with a folded corner -->
    <path
      d="M3.5 1.5h5.75L12.5 4.75v9.75h-9z"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linejoin="round"
    />
    <path
      d="M9.25 1.5v3.25h3.25"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linejoin="round"
    />
    <!-- Magnifier, lens centred on the page body -->
    <circle cx="7.4" cy="8.6" r="2.4" stroke="currentColor" stroke-width="1.3" />
    <path d="M9.15 10.35l2.6 2.6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
  </svg>
</template>
